@import 'styles/mixins';
@import 'styles/variables';

.dateTime {
  @include sm-regular;
  color: var(--neutral-40);
}

.icon {
  display: flex;
  align-self: center;
  color: var(--neutral-40);
}
